import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CdkDrag, CdkDragHandle } from '@angular/cdk/drag-drop';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Clipboard } from '@angular/cdk/clipboard';
import { DomSanitizer } from '@angular/platform-browser';
import { SafeHtml } from '@angular/platform-browser';

function copyToClip(str) {
    function listener(e) {
        e.clipboardData.setData("text/html", str);
        e.clipboardData.setData("text/plain", str);
        e.preventDefault();
    }
    document.addEventListener("copy", listener);
    document.execCommand("copy");
    document.removeEventListener("copy", listener);
};

export class EmailTemplateContentDialogModel {
    public constructor(public dialogueTitle: string, public htmlContent: string) {
    }
}

@Component({
    selector: 'app-email-template-content',
    imports: [CdkDrag, CdkDragHandle, MatDialogModule, MatButtonModule, MatIconModule],
    templateUrl: './email-template-content.dialog.html',
    styleUrls: ['./email-template-content.dialog.scss', '../../../../styles.scss'],
    standalone: true
})
export class EmailTemplateContentDialog implements OnInit {
    // Properties.

    // Constructor.
    public constructor(public dialogRef: MatDialogRef<EmailTemplateContentDialog>,
        @Inject(MAT_DIALOG_DATA) public data: EmailTemplateContentDialogModel,
        private sanitizer: DomSanitizer,
        private clipboard: Clipboard)
    {
    }

    // Life cycle methods.
    public ngOnInit(): void {
    }

    // Methods called by my HTML code.
    public get TestEmailContent(): SafeHtml {
        const html =
            "    <h1>Header 1 </h1> <br><br>\n" +
            "    <span style='font-size: 20pt; color: red;'>Once upon a time ...</span>\n" +
            "<ul>\n" +
            "  <li>plain text editor</li>\n" +
            "  <li> or into a rich text editor </li>\n" + 
            "</ul>\n" +
            "";
        return this.sanitizer.bypassSecurityTrustHtml(html);
    }

    public get EmailContent(): SafeHtml {
        const html = this.data.htmlContent;
        return this.sanitizer.bypassSecurityTrustHtml(html);
    }

    // Handle dialogue actions.
    public oldCopyMessageText(): void {
        //const htmlContent = this.EmailContent;
        //this.clipboard.copy(htmlContent);

        const element = document.getElementById('email-content-p');
        if (element != null) {
            // Legacy approach:
            /*
            //this.clipboard.copy(element.innerHTML);
            const range = document.createRange();

            const selection = window.getSelection();

            range.selectNodeContents(element);

            selection.removeAllRanges();
            selection.addRange(range);

            //window.getSelection()?.removeAllRanges();
            //window.getSelection()?.addRange(range);
            document.execCommand('copy'); // Legacy but effective for rich text
            //window.getSelection()?.removeAllRanges();
            */

            // Newer approach.
            const blobHtml = new Blob([element.innerHTML], { type: 'text/html' });
            //const blobHtml = new Blob([element.innerHTML], { 'text/html' });
            const blobText = new Blob([element.innerText], { type: 'text/plain' });
            const data = [
                new ClipboardItem({
                    ['text/html']: blobHtml,
                    ['text/plain']: blobText
                })
            ];

            /*
            const promise = navigator.clipboard.write(data);
            promise.then(result => {
                console.log('Content copied!');    
            });
            */
            navigator.clipboard.write(data);

            // Second attempt:
            /*
            const clone = element.cloneNode(true);

            // Example: Manually ensure font-size is inline
            const computedStyle = window.getComputedStyle(element);
            clone.style.fontSize = computedStyle.fontSize;
            clone.style.fontFamily = computedStyle.fontFamily;

            const blob = new Blob([clone.outerHTML], { type: 'text/html' });
            const data = [new ClipboardItem({ 'text/html': blob })];
            */
        }
    }

    public copyMessageTextV2(): void {
        const element = document.getElementById('email-content-p');
        if (element != null) {
            const htmlContent = element.innerHTML;
            //const htmlContent = this.EmailContent;

            // Create a temporary element to hold the HTML content
            const tempElement = document.createElement("div");
            tempElement.innerHTML = htmlContent;
            document.body.appendChild(tempElement);
            // Select the HTML content
            const range = document.createRange();
            range.selectNode(tempElement);
            // Copy the selected HTML content to the clipboard
            const selection = window.getSelection();
            selection.removeAllRanges();
            selection.addRange(range);
            document.execCommand("copy");
            selection.removeAllRanges();
            document.body.removeChild(tempElement);
        }
    }

    public copyMessageText(): void {
        const element = document.getElementById('email-content-p');
        if (element != null) {
            const htmlContent = element.innerHTML;

            copyToClip(htmlContent);
        }
    }

    public dismiss(): void {
        this.dialogRef.close(null);
    }
}
